import { createFileRoute } from "@tanstack/react-router";

import { MirrorPage } from "@/components/MirrorPage";
import { content } from "@/mirror/page/careers";
import { requireUnlockedHome } from "@/lib/gate.functions";
import { mirrorHead } from "@/mirror/pages";

export const Route = createFileRoute("/careers")({
  loader: () => requireUnlockedHome(),
  head: () => mirrorHead("careers"),
  component: () => <MirrorPage slug="careers" content={content} />,
});
